import type { FC } from "react"
import React from "react"
import type { DotProps } from "recharts"

const ActiveDotNew: FC<DotProps & { color: string }> = ({
  cx = 0,
  cy = 0,
  color,
}) => (
  <svg
    height={30}
    preserveAspectRatio="xMidYMin slice"
    viewBox="0 0 40 40"
    width={30}
    x={cx - 10}
    y={cy - 10}
  >
    <circle
      cx="13"
      cy="14"
      fill={color}
      r="7"
      strokeDasharray="62.8318"
      strokeDashoffset="0"
      strokeWidth="10"
    />
    <circle
      cx="13"
      cy="14"
      fill="white"
      r="5"
      strokeDasharray="50.2655 50.2655"
      strokeDashoffset="0"
      strokeWidth="6"
    />
    <circle
      cx="13"
      cy="14"
      fill={color}
      r="3"
      strokeDasharray="50.2655 50.2655"
      strokeDashoffset="0"
      strokeWidth="2"
    />

    <circle
      cx="13"
      cy="14"
      fill="white"
      r="1"
      strokeDasharray="50.2655 50.2655"
      strokeDashoffset="0"
      strokeWidth="6"
    />
  </svg>
)

export default ActiveDotNew
